module.exports = "/public/images/4ab376261ef263b39a8a7229033a7d39.png";